import { useTranslations } from '@vocab/react';
import { useToast } from 'braid-design-system';
import type { FC } from 'react';

import type { PageConfig } from 'src/libs/PageConfig';
import type { IJobApplicationStore } from 'src/stores/JobApplicationStore';
import type { IUiStore } from 'src/stores/UiStore';

import ContentWithListContainer from '../../../components/app/ContentWithListContainer';
import Modal from '../../../components/common/Modal';
import { MODAL_NAME } from '../../../constants/modals';

import translations from './.vocab';
import { BulkEmailForm } from './BulkEmailForm';

import * as styles from './BulkEmailModal.css';

export const BulkEmailModal: FC<{
  modalStore: IUiStore['modalStore'];
  jobApplicationStore: IJobApplicationStore;
  addCustomError: PageConfig['dataDogRum']['addCustomError'];
}> = ({ modalStore, jobApplicationStore, addCustomError }) => {
  const { t } = useTranslations(translations);
  const showToast = useToast();

  const modalName = MODAL_NAME.BULK_ACTIONS_EMAIL;

  return (
    <Modal
      modalStore={modalStore}
      name={modalName}
      contentClassName={`${styles.modal} ${styles.email}`}
    >
      {() => (
        <div data-testid="bulk-email-modal" className={styles.bulkModal}>
          <ContentWithListContainer
            listViewHeading={t('Email candidate: labelCount', {
              labelCount: jobApplicationStore.selectedJobApplications.length,
            })}
            selectedJobApplications={
              jobApplicationStore.selectedJobApplications
            }
          >
            <BulkEmailForm
              onCancel={() => modalStore.removeModal(modalName)}
              closeAndShowSuccessMessage={(message, description, action) => {
                showToast({
                  message,
                  description,
                  tone: 'positive',
                  action,
                  closeLabel: t('Close'),
                });
                modalStore.removeModal(modalName);
              }}
              jobApplicationStore={jobApplicationStore}
              selectedJobApplicationsCount={
                jobApplicationStore.selectedJobApplications.length
              }
              addCustomError={addCustomError}
            />
          </ContentWithListContainer>
        </div>
      )}
    </Modal>
  );
};
